import styled from 'styled-components';

const Paragraph = styled.p`
  font-size: 24px;
  line-height: 29px;

  @media only screen and (max-width: 810px) {
    font-size: 16px;
    line-height: 19px;
  }
`;

export default Paragraph;
